export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '3.6.13',
};
